import { useEffect, useRef } from 'react';

type Props = {
  handler: () => void;
  listenCapturing?: boolean;
};

export function useOutsideClick<T extends HTMLElement = HTMLDivElement>({ handler, listenCapturing = true }: Props) {
  const ref = useRef<T>(null);

  useEffect(() => {
    function handleClick(e: Event) {
      // if the DOM node exists (the div styledmodal) and
      // if the div (stylesmodal) does not contain the element that was click the e.target then close the modal.
      if (ref.current && !ref.current.contains(e.target as Node)) {
        handler();
      }
    }

    document.addEventListener('click', handleClick, listenCapturing);
    return () =>
      document.removeEventListener('click', handleClick, listenCapturing);
  }, [handler, listenCapturing]);

  return ref;
}
